export default "__VITE_ASSET__h1GYqHXw__"